import { useHistory, useParams } from "react-router-dom";
import { Alert, Badge, Button, Card } from "react-bootstrap";

const RouteViewPage = () => {
  const history = useHistory();
  const { id } = useParams();

  const locationState = history.location.state || {};
  const route = locationState.route || null;

  const goBack = () => history.push("/jeep-rally/routes");

  if (!route) {
    return (
      <div className="container-fluid">
        <div className="card">
          <div className="card-body">
            <Alert variant="danger" className="mb-0">
              Route not found. Please open it from the Routes list.
            </Alert>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-header d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-2">
            <button
              type="button"
              className="btn btn-link p-0 text-decoration-none"
              onClick={goBack}
              aria-label="Back to routes list"
              title="Back"
            >
              <i className="bi bi-arrow-left fs-4" />
            </button>
            <h4 className="card-title mb-0">View Route</h4>
          </div>
        </div>

        <div className="card-body">
          <Card className="shadow-none">
            <Card.Body>
              <h5 className="mb-1">{route.title || route.name || "-"}</h5>
              <div className="text-muted mb-3">
                Route ID: <code>{id}</code>
              </div>

              <div className="d-flex gap-3 flex-wrap mb-3">
                <Badge bg="secondary">
                  Distance: {route.total_distance_km ?? "-"} km
                </Badge>
                <Badge bg="info">
                  Estimated: {route.estimated_time || "-"}
                </Badge>
              </div>

              <div>
                <div className="text-muted mb-1">Description</div>
                <div>{route.description || "-"}</div>
              </div>

              <div className="d-flex justify-content-end mt-4">
                <Button variant="outline-secondary" onClick={goBack}>
                  Back
                </Button>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default RouteViewPage;

